// @ts-nocheck
import { getPdfPrint } from "@store/Framework/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type GetQuotePdfPrintParameter = {
    quoteId: string;
    canShowPrice: boolean;
    orderNumber: string;
};
type Props = {
    apiParameter: GetQuotePdfPrintParameter;
};

type HandlerType = Handler<GetQuotePdfPrintParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = props => {
    getPdfPrint(props.apiParameter);
};

export const chain = [PopulateApiParameter, RequestDataFromApi];

const getQuotePdfPrint = createHandlerChainRunner(chain, "GetQuotePdfPrint");
export default getQuotePdfPrint;
